'use client'

import { useRef } from 'react'
import { gsap } from 'gsap'
import { useLanguage } from '../../providers/LanguageProvider'

const ExperiencedManagement = () => {
  const blackOverlayRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLDivElement>(null)
  const { language } = useLanguage()
  const isArabic = language === 'ar'

  const handleEnter = () => {
    gsap.to(blackOverlayRef.current, {
      y: '0%',
      duration: 0.4,
      ease: 'power2.inOut',
    })

    gsap.to(textRef.current, {
      boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.3)',
      duration: 0.4,
    })
  }

  const handleLeave = () => {
    gsap.to(blackOverlayRef.current, {
      y: '-120%',
      duration: 0.4,
      ease: 'power2.inOut',
    })

    gsap.to(textRef.current, {
      boxShadow: '0px 0px 0px rgba(0, 0, 0, 0)',
      duration: 0.4,
    })
  }

  return (
    <div
      className="relative order-2 md:order-2 col-span-1 h-[220px] sm:h-[250px] xl:h-[286px] 2xl:h-[330px] overflow-hidden cursor-pointer group"
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      {/* Base background */}
      <div className="absolute inset-0 bg-[#EE3E25] z-0" />

      {/* Animated black overlay */}
      <div
        ref={blackOverlayRef}
        className="absolute scale-105 inset-0 bg-black z-10 translate-y-[-120%]"
      />

      {/* Text content */}
      <div
        ref={textRef}
        className="relative z-10 h-full sm:p-5 p-2.5 md:p-3 xl:p-6 flex flex-col justify-between text-white"
      >
        {isArabic ? (
          <div className="flex flex-col justify-between h-full">
            <h3 className="text-[18px] sm:text-[17px] md:text-[15px] lg:text-[16px] xl:text-[22px] 2xl:text-[22px] font-semibold leading-6 sm:leading-7 2xl:leading-8">
              إدارة ذات خبرة
            </h3>
            <p className="text-xs sm:text-sm xl:text-base 2xl:text-[16px] text-[#F8F8F8] font-light">
              أكثر من 20 عامًا من الخبرة في إدارة مستودعات الحاويات عبر شركة كونتيننتال التجارية
            </p>
          </div>
        ) : (
          <div className="flex flex-col justify-between h-full">
            <h3 className="text-[16px] sm:text-[17px] md:text-[15px] lg:text-[16px] xl:text-[22px] 2xl:text-[22px] font-semibold leading-6 sm:leading-7 2xl:leading-8">
              Experienced <br /> Management
            </h3>
            <p className="text-[13px] sm:text-sm xl:text-base 2xl:text-[16px] text-[#F8F8F8] font-light">
              Built on 20 years of <br /> container depot <br /> success.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default ExperiencedManagement
